import {useState} from 'react';
import { useRouter } from "next/router";
import { Button,Flex } from "@chakra-ui/react";
import { AiOutlineReload } from "react-icons/ai";
export function Reload(props) {
  const {replace,asPath} = useRouter();
  const [Load,setLoad] = useState(false);
  return (
    <Flex justifyContent="center" my={["36", "48", "64", "xl"]}>
      <Button
        isLoading={Load}
        loadingText="🔥 Reloading..."
        rightIcon={<AiOutlineReload />}
        aria-label="Reload"
        onClick={() => {
          replace(asPath),
          setLoad(true);
        }}
      >
        {props.text}
      </Button>
    </Flex>
  );
}
